<!--  menuThree  对应 二级导航的样式4 -->
<template>
  <div class="custom-submenu" :style="style" ref="customSubMenu">
    <div class="menu-container" :style="containerStyle">
      <div class="second-menu" v-for="(menu, index) in menuData" :key="menu.label">
        <div style="display: flex;">
          <div :class="activeIndex === [menuIndex, index].join('_') ? 'second-menu-title text-overflow is-active' : 'second-menu-title text-overflow'" :title="menu.name" @click="handleSubMenuSelect([menuIndex, index])">
          <span v-if="getIconPosition === 'right'">{{
              menu.label
            }}
          </span>
          <cxIcon class="icon" v-if="iconSet.iconType === 'icon' && iconSet.showIcon !== false" :options="titleIcon" :style="titleIconStyle"></cxIcon>
          <img class="icon" v-else-if="iconSet.iconType === 'img' && iconSet.iconSrc && iconSet.showIcon !== false" :src="iconSet.iconSrc" :style="titleIconStyle"/>
          <span v-if="getIconPosition === 'left'">
            {{
              menu.label
            }}
          </span>
        </div>
        </div>
      <div class="third-menu-container" v-if="menu.children && menu.children.length">
        <div class="third-menu" v-for="(subMenu, subMenuIndex) in menu.children.slice(0, maxThreeMenus)" :key="subMenu.label">
          <p :class="activeIndex === [menuIndex, index, subMenuIndex].join('_') ? 'third-menu-title is-active' : 'third-menu-title'"
            :title="menu.name" 
            @click="handleSubMenuSelect([menuIndex, index, subMenuIndex])">{{ subMenu.label }}</p>
        </div>
        <el-button type="default" v-if="menu.children.length > maxThreeMenus" @click="handleSubMenuSelect([menuIndex, index])" size="mini">更多</el-button>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import { isPlainObject, customUnitTranform, isSsrPage, remCheck } from '@/utils/index'
import defaultProps, { propTypeMap, unitMap } from './defaultProps.js'
import propTrans from './../setting/propTrans.js'
import $ from 'jquery'
export default {
  props: {
    menuIndex: Number,
    menuData: {
      type: Array,
    },
    config: {
      type: Object,
      default: () => Object.create(null)
    },
    currentMenuIndex: undefined
  },
  watch: {
    pageWidth(newVal) {
      this.$nextTick(() => {
        newVal && setTimeout(() => {
          this.checkLeftPosition()
        }, 500)
      })
    },
    zoomActual() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.checkLeftPosition()
        }, 1000)

      })
    },
    'finalConfig.showConnector': function() {
      this.$eventBus.$emit("updateConnectorStyle")
      this.$nextTick(() => {
        this.checkLeftPosition()
      })
    },
    'finalConfig.connectorWidth': function() {
      this.$eventBus.$emit("updateConnectorStyle")
    },
    'finalConfig.connectorColor': function() {
      this.$eventBus.$emit("updateConnectorStyle")
    },
    'finalConfig.ulMargin': function() {
      this.$nextTick(() => {
        this.checkLeftPosition()
      })
    },
    'finalConfig.ulWidthType': function() {
      this.$nextTick(() => {
        this.checkLeftPosition()
      })
    }
  },
  data() {
    return {
      leftPos: 0,
      defaultProps: JSON.parse(JSON.stringify(defaultProps)),
      activeIndex: ""
    }
  },
  computed: {
    zoomActual() {
      return this.$store.state.states.zoomActual
    },
    showAllScreen() {
      // 开启了适应屏幕宽度
      return !this.$store.state.states.showAllScreen
    },
    finalConfig() {
      const config = {...this.defaultProps}
      Object.entries(this.config).forEach(([key, value]) => {
        if (isPlainObject(value) && isPlainObject(config[key])) {
          config[key] = {...config[key], ...value}
        } else if ([Boolean, String, Number].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        } else {
          config[key] = this.config[key] ?? config[key]
        }
      })
      Object.entries(config).forEach(([key, value]) => {
        if (['number', 'string'].includes(typeof value)) {
          config[key] = value + (unitMap[key] || '')
        }
        if (propTrans[propTypeMap[key]]) {
          config[key] = propTrans[propTypeMap[key]](value)
        }
      })
      this.$emit('menuLoaded', {index: this.menuIndex, config: this.config, styleId: 4, finalConfig: config})
      return config
    },
    style() {
      const styleObject = {}
      Object.entries(this.finalConfig).forEach(([key, value]) => {
        if (isPlainObject(value)) {
          Object.entries(value).forEach(([subKey, value]) => {
            styleObject[`--${key}_${subKey}`] = customUnitTranform(subKey, value)
          })
        } else {
          styleObject[`--${key}`] = customUnitTranform(key, value)
        }
      })
      // styleObject.left = (window.innerWidth - this.pageWidth) / 2 - this.leftPos + 'px'
      styleObject.width =  this.finalConfig.ulWidthType === 'fullPage' ? `calc(${100 / this.zoomActual}vw - ${2 * parseFloat(this.finalConfig.ulMargin)}px)` : this.pageWidth
      styleObject.height = this.finalConfig?.navSize?.height
      if (!this?.finalConfig?.showThirdBorder) {
        styleObject['--thirdTitleBorder_borderWidth'] = '0px'
      }
      if (!this?.finalConfig?.showThirdHoverBorder) {
        styleObject['--thirdTitleHoverBorder_borderWidth'] = '0px'
      }
      return styleObject
    },
    getIconPosition() {
      return this.finalConfig.secondNavIcon?.iconPosition
    },
    iconSet() {
      return this.finalConfig.secondNavIcon
    },
    titleIcon() {
      return {
        iconSrc: this.iconSet.iconSrc,
        iconWidth: this.iconSet.iconWidth,
        iconMargin: this.iconSet.iconMargin,
        iconPosition: this.iconSet.iconPosition
      }
    },
    zoom() {
      return this.$store.state.states.zoom
    },
    titleIconStyle() {
      const data = this.iconSet
      return {
        '--color': data.iconColor,
        fontSize: remCheck(data.iconWidth),
        width: remCheck(data.iconWidth),
        height: remCheck(data.iconWidth),
        margin: data.iconPosition === "left"
          ? `0 ${remCheck(data.iconMargin)} 0 0`
          : `0 0 0 ${remCheck(data.iconMargin)}`
      }
    },
    pageWidth() {
      return remCheck(this.$store.state[this.request_prefix].page.pageWidth) ?? "1920px"
    },
    containerStyle() {
      return {
        width: '100%',
      }
    },
    maxThreeMenus() {
      return this.config.thirdNavColumns
    },
    showMoreBtn() {
      return this.config.thirdNavShowMore
    }
  },
  methods: {
    handleSubMenuSelect(pathArr) {
      this.activeIndex = pathArr.join('_')
      this.$emit('subMenuSelect', pathArr.join('_'))
    },
    checkLeftPosition() {
      const contentContainer = document.querySelector(".content_p_helper").getBoundingClientRect()
      const originPageWidth = parseFloat(this.pageWidth)
      const parentSubMenuDom = $(this.$refs.customSubMenu).parents(".el-submenu")?.[0]
      const zoom = 1
      const bodyWidth = parseFloat(getComputedStyle(document.body).width)
      let translateLeft = 0
      if (parentSubMenuDom) {
        this.leftPos = parentSubMenuDom?.getBoundingClientRect()?.left
        if (this.finalConfig.ulWidthType === 'fullPage') {
          translateLeft = (parseFloat(this.finalConfig.ulMargin) - this.leftPos) / this.zoomActual
        } else {
          if (this.showAllScreen) {
            // 说明是未缩放的情况, 按照版心计算来获取偏移值
            translateLeft = (bodyWidth - originPageWidth) / 2 - this.leftPos
          } else {
            // 说明是缩放情况，此时只需要和content_p_helper的中线对齐，就一定是对齐的
            const centerLineLeft = contentContainer.width / 2 + contentContainer.left
            translateLeft = (centerLineLeft - 0.5 * (originPageWidth * this.zoomActual) - this.leftPos) / this.zoomActual
          }
        }
        parentSubMenuDom.querySelector(".el-menu--horizontal") &&
            (parentSubMenuDom.querySelector(".el-menu--horizontal").style.transform = `translate(${translateLeft}px, ${this.finalConfig.showConnector ? 25: 0}px)`)
          if (parentSubMenuDom.querySelector(".el-menu--horizontal")) {
            parentSubMenuDom.querySelector(".el-menu--horizontal").style.setProperty("left", 0, "important")
          }
        let ulTop = parseInt(getComputedStyle(parentSubMenuDom).getPropertyValue("--ulTopDefault"))
        parentSubMenuDom.style.setProperty("--ulTop", ulTop)
      }
    }
  },
  mounted() {
    this.$emit('menuLoaded', {index: this.menuIndex, config: this.config, styleId: 4, finalConfig: this.finalConfig})
    if (!isSsrPage()) {
      this.checkLeftPosition()
    }
  }
}
</script>
<style lang="scss" scoped>
.text-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-submenu {
  box-sizing: border-box;
  padding: var(--navPadding);
  border-style: var(--navBorder_borderStyle);
  border-width: var(--navBorder_borderWidth);
  border-color: var(--navBorder_borderColor) !important;
  border-radius: var(--navBorderRadius);
  background-color: var(--wholeBackground_backgroundColor);
  background-image: var(--wholeBackground_backgroundImage);
  background-repeat: var(--wholeBackground_backgroundRepeat);
  background-position: var(--wholeBackground_backgroundPosition);
  background-size: var(--wholeBackground_backgroundSize);
  box-shadow: var(--navBoxShadow);
  font-family: "PingFang SC";
  position: relative;
  //justify-content: center
  justify-content: var(--navSite_alignmentType);
  overflow-x: hidden;
  overflow-y: auto;
  margin: 0 auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc; // 滑块颜色
    border-radius: 4px; // 滑块圆角
  }
}
.second-menu {
  flex: 1;
  overflow: hidden;
  &:not(:last-child) {
    margin-bottom: var(--navGap);
  }
}
.second-menu-title {
  display: flex;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  font-family: var(--secondNavTitle_fontFamily);
  font-size: var(--secondNavTitle_fontSize);
  font-weight: var(--secondNavTitle_fontWeight);
  line-height: var(--secondNavTitle_lineHeight);
  text-align: var(--secondNavTitle_textAlign);
  letter-spacing: var(--secondNavTitle_letterSpacing);
  text-decoration: var(--secondNavTitle_textDecoration);
  font-style: var(--secondNavTitle_fontStyle);
  color: var(--secondNavTitle_fontColor);
  writing-mode: var(--secondNavTitle_writingMode);
  border-width: var(--secondNavTitleBorder_borderWidth);
  border-color: var(--secondNavTitleBorder_borderColor) !important;
  border-style: var(--secondNavTitleBorder_borderStyle);
  padding: var(--secondNavPadding);
  text-shadow: var(--secondNavTitle_textShadow);
  background-repeat: var(--secondNavTitleBackground_backgroundRepeat);
  background-image: var(--secondNavTitleBackground_backgroundImage);
  background-color: var(--secondNavTitleBackground_backgroundColor);
  background-size: var(--secondNavTitleBackground_backgroundSize);
  background-position: var(--secondNavTitleBackground_backgroundPosition);
  border-radius: var(--secondNavBorderRadius);
  cursor: pointer;
  &:hover {
    padding: var(--secondNavHoverPadding);
    font-size: var(--secondNavHoverTitle_fontSize);
    font-weight: var(--secondNavHoverTitle_fontWeight);
    line-height: var(--secondNavHoverTitle_lineHeight);
    text-align: var(--secondNavHoverTitle_textAlign);
    letter-spacing: var(--secondNavHoverTitle_letterSpacing);
    text-decoration: var(--secondNavHoverTitle_textDecoration);
    font-style: var(--secondNavHoverTitle_fontStyle);
    color: var(--secondNavHoverTitle_fontColor);
    text-shadow: var(--secondNavHoverTitle_textShadow);
    writing-mode: var(--secondNavHoverTitle_writingMode);
    border-width: var(--secondNavTitleHoverBorder_borderWidth);
    border-color: var(--secondNavTitleHoverBorder_borderColor) !important;
    border-style: var(--secondNavTitleHoverBorder_borderStyle);
    border-radius: var(--secondHoverRadius);
    background-repeat: var(--secondHoverNavTitleBackground_backgroundRepeat);
    background-image: var(--secondHoverNavTitleBackground_backgroundImage);
    background-color: var(--secondHoverNavTitleBackground_backgroundColor);
    background-size: var(--secondHoverNavTitleBackground_backgroundSize);
    background-position: var(--secondHoverNavTitleBackground_backgroundPosition);
  }
  &.is-active {
    padding: var(--secondNavActivePadding);
    font-size: var(--secondNavActiveTitle_fontSize);
    font-weight: var(--secondNavActiveTitle_fontWeight);
    line-height: var(--secondNavActiveTitle_lineHeight);
    text-align: var(--secondNavActiveTitle_textAlign);
    letter-spacing: var(--secondNavActiveTitle_letterSpacing);
    text-decoration: var(--secondNavActiveTitle_textDecoration);
    font-style: var(--secondNavActiveTitle_fontStyle);
    color: var(--secondNavActiveTitle_fontColor);
    text-shadow: var(--secondNavActiveTitle_textShadow);
    writing-mode: var(--secondNavActiveTitle_writingMode);
    border-width: var(--secondNavTitleActiveBorder_borderWidth);
    border-color: var(--secondNavTitleActiveBorder_borderColor) !important;
    border-style: var(--secondNavTitleActiveBorder_borderStyle);
    border-radius: var(--secondActiveRadius);
    background-repeat: var(--secondActiveNavTitleBackground_backgroundRepeat);
    background-image: var(--secondActiveNavTitleBackground_backgroundImage);
    background-color: var(--secondActiveNavTitleBackground_backgroundColor);
    background-size: var(--secondActiveNavTitleBackground_backgroundSize);
    background-position: var(--secondActiveNavTitleBackground_backgroundPosition);
  }
}
.menu-container {
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc; // 滑块颜色
    border-radius: 4px; // 滑块圆角
  }
}
.title-icon {
  display: inline-block;
  color: var(--secondNavIcon_iconColor);
  font-size: var(--secondNavIcon_iconWidth);
  width: var(--secondNavIcon_iconWidth);
  height: var(--secondNavIcon_iconWidth);
}
.third-menu-container {
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 0 12px;
  padding: var(--thirdNavPadding);
  gap: var(--thirdNavTitleMargin_topMargin) var(--thirdNavTitleMargin_leftMargin);
}
.third-menu-title {
  width: 100%;
  line-height: var(--thirdNavTitle_lineHeight);
  text-align: var(--thirdNavTitle_textAlign);
  font-size: var(--thirdNavTitle_fontSize);
  font-weight: var(--thirdNavTitle_fontWeight);
  color: var(--thirdNavTitle_fontColor);
  letter-spacing: var(--thirdNavTitle_letterSpacing);
  text-decoration: var(--thirdNavTitle_textDecoration);
  font-style: var(--thirdNavTitle_fontStyle);
  writing-mode: var(--thirdNavTitle_writingMode);
  text-shadow: var(--thirdNavTitle_textShadow);
  cursor: pointer;
  background-repeat: var(--thirdNavTitleBackground_backgroundRepeat);
  background-image: var(--thirdNavTitleBackground_backgroundImage);
  background-color: var(--thirdNavTitleBackground_backgroundColor);
  background-size: var(--thirdNavTitleBackground_backgroundSize);
  background-position: var(--thirdNavTitleBackground_backgroundPosition);
  border-width: var(--thirdTitleBorder_borderWidth);
  border-color: var(--thirdTitleBorder_borderColor) !important;
  border-style: var(--thirdTitleBorder_borderStyle);
  border-radius: var(--thirdRadius);
  &:hover {
    text-shadow: var(--thirdHoverNavTitle_textShadow);
    text-align: var(--thirdHoverNavTitle_textAlign);
    font-size: var(--thirdHoverNavTitle_fontSize);
    font-weight: var(--thirdHoverNavTitle_lineHeight);
    color: var(--thirdHoverNavTitle_fontColor);
    letter-spacing: var(--thirdHoverNavTitle_letterSpacing);
    text-decoration: var(--thirdHoverNavTitle_textDecoration);
    font-style: var(--thirdHoverNavTitle_fontStyle);
    writing-mode: var(--thirdHoverNavTitle_writingMode);
    background-repeat: var(--thirdHoverNavTitleBackground_backgroundRepeat);
    background-image: var(--thirdHoverNavTitleBackground_backgroundImage);
    background-color: var(--thirdHoverNavTitleBackground_backgroundColor);
    background-size: var(--thirdHoverNavTitleBackground_backgroundSize);
    background-position: var(--thirdHoverNavTitleBackground_backgroundPosition);
    border-radius: var(--thirdHoverRadius);
    border-width: var(--thirdTitleHoverBorder_borderWidth);
    border-color: var(--thirdTitleHoverBorder_borderColor) !important;
    border-style: var(--thirdTitleHoverBorder_borderStyle);
  }
  &.is-active {
    text-shadow: var(--thirdActiveNavTitle_textShadow);
    text-align: var(--thirdActiveNavTitle_textAlign);
    font-size: var(--thirdActiveNavTitle_fontSize);
    font-weight: var(--thirdActiveNavTitle_lineHeight);
    color: var(--thirdActiveNavTitle_fontColor);
    letter-spacing: var(--thirdActiveNavTitle_letterSpacing);
    text-decoration: var(--thirdActiveNavTitle_textDecoration);
    font-style: var(--thirdActiveNavTitle_fontStyle);
    writing-mode: var(--thirdActiveNavTitle_writingMode);
    background-repeat: var(--thirdActiveNavTitleBackground_backgroundRepeat);
    background-image: var(--thirdActiveNavTitleBackground_backgroundImage);
    background-color: var(--thirdActiveNavTitleBackground_backgroundColor);
    background-size: var(--thirdActiveNavTitleBackground_backgroundSize);
    background-position: var(--thirdActiveNavTitleBackground_backgroundPosition);
    border-radius: var(--thirdActiveRadius);
    border-width: var(--thirdTitleActiveBorder_borderWidth);
    border-color: var(--thirdTitleActiveBorder_borderColor) !important;
    border-style: var(--thirdTitleActiveBorder_borderStyle);
  }
}
</style>
